<template>
  <div
    class="c-book-topbar navbar is-fixed-top has-text-white"
    v-show="showBars">
    <div class="c-book-topbar__container container is-fluid">
      <a href="#" v-if="isModalOpenOnTablet" @click.prevent="closeModal()"
        class="c-book-topbar__back-link">
        <back-arrow/>
        <span class="c-book-topbar__back-title">{{ $t('BACK_TO_THE_BOOK') }}</span>
      </a>

      <nav v-else class="c-book-topbar__content navbar level">
        <router-link to="/library" class="c-book-topbar__back-link" :aria-label="$t('BACK_TO_LIBRARY')">
          <back-arrow/>
          <span class="c-book-topbar__back-title">{{ $t('LIBRARY') }}</span>
        </router-link>
        <div class="c-book-topbar__logo">
          <offline-badge
            v-if="!connection"
            class="c-book-topbar__offline-badge"></offline-badge>
          <figure class="c-book-topbar__figure media-content is-centered level-item" alt="D-bok logo">
            <d-bok-logo></d-bok-logo>
          </figure>
        </div>
        <div class="c-book-topbar__svg-wrapper">
          <book-menu-button :modalType="'SEARCH_IN_BOOK'" variant="icon-only">
            <search-icon class="c-book-topbar__svg"/>
          </book-menu-button>
          <book-menu-button :modalType="'TABLE_OF_CONTENTS'" variant="icon-only">
            <table-icon class="c-book-topbar__svg"/>
          </book-menu-button>
          <book-menu-button :modalType="'NOTES'" variant="icon-only">
            <notebook class="c-book-topbar__svg"/>
          </book-menu-button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import OfflineBadge from './OfflineBadge'
import DbokLogo from '@/assets/svg/DbokLogo'
import BackArrow from '@/assets/svg/BackArrow'
import SearchIcon from '@/assets/svg/SearchIcon'
import Notebook from '@/assets/svg/Notebook'
import TableIcon from '@/assets/svg/TableIcon'
import BookMenuButton from '@/components/BookMenuButton'

export default {
  name: 'book-topbar',

  components: {
    'offline-badge': OfflineBadge,
    'd-bok-logo': DbokLogo,
    'back-arrow': BackArrow,
    'search-icon': SearchIcon,
    'table-icon': TableIcon,
    'notebook': Notebook,
    'book-menu-button': BookMenuButton
  },

  props: {
    connection: {
      type: Boolean
    },
    showBars: Boolean
  },

  computed: {
    isModalOpenOnTablet() {
      return this.modalIsOpen && this.responsive !== 'desktop'
    },
    ...mapState('bookMenu', {
      modalIsOpen: state => state.isOpen
    }),
    ...mapState('userSettings', {
      responsive: state => state.responsive
    })
  },

  methods: {
    ...mapActions({
      closeModal: 'bookMenu/closeModal'
    }),
    toggleBar() {
      this.$emit('toggle-bars')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-book-topbar,
.c-book-topbar__content {
  background: $blue;
  width: 100%;
  display: flex;
  max-height: 65px;
}

.c-book-topbar__logo {
  min-height: 65px;
  justify-content: left;
  margin-bottom: 0;
  width: 50%;
  @media screen and (min-width: 768px) {
    width: 55%;
  }
  @media screen and (min-width: 943px) {
    width: 65%;
  }
}

.c-book-topbar__figure {
  position: absolute;
  left: 0;
  right: 0;
  width: 65px;
  height: 65px;
  margin: auto;
  top: 0;
}

.c-book-topbar__container {
  margin: 0;
  display: flex;
}

.c-book-topbar__content {
  margin: 0 !important;
  position: static;
}

.c-book-topbar__back-link {
  font-size: 20px;
  font-weight: 300;
  color: $white;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 65px;
  padding: 0 1em;
  &:hover {
    background-color: $lighter-dark-blue;
  }

  @include a11yOutlineWithOffset();
}

.c-book-topbar__offline-badge {
  margin-left: 2em;
  top: .75em;
}

.c-book-topbar__svg-wrapper {
  margin-right: 1.5em;
  height: 100%;
}

.c-book-topbar__svg {
  margin: auto 8px;
  display: block;
  cursor: pointer;
}
</style>
